import React from 'react'
import { PageContainer, Row, Column } from 'components/base/grid/grid'
import { H1 } from 'components/base/typography/headings'
import NotFound from 'components/notFound'

const ErrorPage = () => {
	return <NotFound />
}

export default ErrorPage
